import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import PcModelIntroSpecs from '../PcModelIntroSpecs';
import styles from './styles';

const PcModelIntro = ({ modelTheme }) => {
  const { pcModel } = usePcConfigurator();
  const breadcrumbs = modelTheme?.breadcrumbs;
  const bannerTheme = {
    isLeftOffsetText: modelTheme.position === 'Left',
    isLightText: modelTheme.color === 'Light',
  }; // IF PCMODEL DATA NEED TO HAVE THESE PROPERTIES

  const thumb_image = modelTheme?.thumb_image != null ? modelTheme?.thumb_image : pcModel?.thumb_image

  return (
    <>
      <section
        className="pc_model_intro"
        // style={{
        //   backgroundImage: `url(${pcModel?.image})`,
        // }}
      >
        <div className="content_wrapper">
          <ul className="breadcrumbs">
            {breadcrumbs?.map((item, idx) => (
              <li key={idx} className={`bread${idx}`}>
                {idx > 0 && (
                  <img draggable="false"
                    src={
                      bannerTheme.isLightText
                        ? '/icons/icon_right_grey.svg'
                        : '/icons/icon_right_dark.svg'
                    }
                    className="breadcrumbs_arrow"
                    alt="arrow_icon"
                  />
                )}
                <a href={item.link}>{item.link_title}</a>
              </li>
            ))}
            <li className={`breadLast`}>
              <img draggable="false"
                src={
                  bannerTheme.isLightText
                    ? '/icons/icon_right_grey.svg'
                    : '/icons/icon_right_dark.svg'
                }
                className="breadcrumbs_arrow"
                alt="arrow_icon"
              />
              <a>{pcModel.model_title}</a>
            </li>
          </ul>
          <div className="content">
            <div className="title">{pcModel.model_title}</div>
            <div className="description">{pcModel.model_description}</div>
            <div className="price_section">
              <span className="currency">Starting from MYR</span>
              <div className="product_price">
                RM {parseFloat(pcModel?.price).toLocaleString()}
              </div>
            </div>

            {/* <div className="specification_wrapper">
              <PcModelIntroSpecs isLightText={bannerTheme.isLightText} />
            </div> */}
          </div>
          <div></div>
          
          <div className="disclaimer">
            *Image may not represent your specifications. Please refer to
            information below.
          </div>
        </div>
        <div className="banner_image" />
      </section>
      {/* <style jsx>{styles}</style> */}
      <style jsx>{`
        .banner_image {
          background-image: url('${pcModel?.image}');
          background-repeat: no-repeat;
          background-size: cover;
          background-position: right;
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          z-index: 0;
          max-width: 1440px;
          margin: auto;
        }
        .pc_model_intro {
          position: relative;
          margin: auto;
          color: ${bannerTheme.isLightText ? '#e4e4e4' : '#242424'};
        }
        .content_wrapper {
          position: relative;
          height: 440px;
          max-width: 1440px;
          margin: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 16px 48px;
          z-index: 1;
        }
        .breadcrumbs {
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;
          color: ${bannerTheme.isLightText ? '#949494' : '#242424'};
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .breadcrumbs li {
          align-items: center;
          display: flex;
        }
        .breadcrumbs_arrow {
          opacity: 0.75;
          margin: 0px 13.53px;
        }
        .breadLast a {
          color: ${bannerTheme.isLightText ? '#e4e4e4' : '#000000'};
          font-weight: ${bannerTheme.isLightText ? '400' : '600'};
        }
        .content {
          flex: ${bannerTheme.isLeftOffsetText ? '0' : '1'};
          padding: 12px;
          align-self: ${bannerTheme.isLeftOffsetText ? 'flex-start' : 'center'};
          width: 40%;
        }
        .title {
          font-family: big_noodle_titling;
          font-size: 39px;
          font-weight: 400;
          line-height: 64px;
          letter-spacing: 0em;
          text-align: center;
        }
        .price_section {
          justify-content: center;
          line-height: 24px;
          font-weight: 400;
          font-family: 'big_noodle_titling';
          font-size: 39px;
          letter-spacing: 0;
          text-align: center;
          margin-top: 9px;
          display: flex;
        }
        .currency {
          font-size: 16px;
          font-family: 'Roboto-Medium';
        }
        .product_price {
          margin-left: 10px;
          font-weight: 400;
        }
        .specification_wrapper {
          display: flex;
          justify-content: center;
          margin-top: 9px;
        }
        .disclaimer {
          font-family: 'Roboto-Medium';
          font-size: 10px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          margin-top: 10px;
          text-align: right;
        }
        @media (min-width: 768px) {
          .title {
            text-align: left !important;
          }
          .price_section {
            justify-content: left !important;
            text-align: left !important;
          }
        }
        @media (max-width: 1024px) {
          .content {
            width: 50%;
          }
        }
        @media (max-width: 768px) {
          .banner_image {
            display: none;
          }
          .pc_model_intro {
            background-image: url('${thumb_image}') !important;
            background-position: center;
            background-size: cover;
          }
          .content_wrapper {
            height: 469px;
          }
          .content {
            width: 100%;
            flex: 1;
          }
          .disclaimer {
            text-align: center;
          }
        }
        @media (max-width: 640px) {
          .bread0 {
            display: none !important;
          }
          .bread1 {
            display: none !important;
          }
          .bread2::before {
            content: '...';
          }

          .title {
            font-family: big_noodle_titling;
            font-size: 33px;
            font-weight: 400;
            line-height: 40px;
            letter-spacing: 0em;
          }
          .content_wrapper {
            padding: 8px 16px;
          }

          .price_section {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 5px;
          }
          .specification_wrapper {
            margin-top: 5px;
          }
        }
      `}</style>
    </>
  );
};

export default PcModelIntro;
